import { Form } from 'react-router-dom'
import React, { useState, useContext, useEffect, useRef } from 'react';
import Application from "../../../StateContext/Application";
const CreateDepartment = () => {
    const [Department, SetDepartment] = useState('');
    const [options, setOptions] = useState([]);
    const [show, setshow] = useState(true)
    const [menu, setmenu] = useState([])
    const [expandedMenuId, setExpandedMenuId] = useState(null);

    const statecalls = useContext(Application);
    const { Usermenu, DepartmentHandler } = statecalls;
      const formdataref = useRef(null)
    
    useEffect(() => {
        async function getmenus() {
            try {
                let menu = await Usermenu();
                setOptions(menu.result || []);
            } catch (error) {
                console.error(error);
            }
        }
        getmenus()
    }, [])

    async function objectpusher(ev, menuname) {
        try {
            if (ev.checked) {
                menu.push(menuname);
            } else {
                let menuarray = []
                menu.forEach((e) => {
                    if (e !== menuname) {
                        menuarray.push(e);
                    }
                });
                setmenu(menuarray);
            }
        } catch (error) {
            console.error(error);
        }
    }


    const CreateDepartment = async () => {
        try {
            let condition = await DepartmentHandler('insert', Department, menu);
            setshow(condition);
            alert("Department Created Successfully")
        } catch (error) {
            console.error(error);
        }
    }
    const toggleMenu = (menuId) => {
        setExpandedMenuId(expandedMenuId === menuId ? null : menuId);
    };
    const resetData = () => {
        formdataref.current.reset()
        setmenu([]); 
        SetDepartment('');
      }
    return (
        <div style={{backgroundColor:'#f4f7fe', overflowY: 'auto', maxHeight: '91vh', height: '94vh'}}>
            <h5 style={{ textAlign: 'center' }}>CreateDepartment</h5>
            <Form onSubmit={CreateDepartment} ref={formdataref} style={{ padding: '20px',display:'grid',gap:'1rem' }}>
                <div style={{display:'flex',backgroundColor:'white',borderRadius:'10px',boxShadow:'0px 0px 3px',justifyContent:'center',paddingTop:'10px'}}>
                    <div style={{width:'95%'}}>
                        <label style={{fontWeight:'600'}}>Department Name</label>
                        <input type='text' onChange={(e) => SetDepartment(e.target.value)} placeholder='Enter Department Name Here' required className='form-control my-3'></input>
                    </div>
                </div>
                {show ? options.map((e, index) => {
                    if (e.Summenuid === 0) {
                        return (
                            <>
                                <div key={index} className="accordion" id="accordionPanelsStayOpenExample" style={{ padding: 10, border: "3px solid lightgray", borderRadius: 7, backgroundColor: 'white' }}>
                                    <div className="accordion-item" style={{ border: 'none' }} >
                                        <h2 className="accordion-header" id={`heading-${e.Menu_ID}`} style={{ display: 'flex', alignItems: 'center', justifyContent: 'end', backgroundColor: 'lightgray', borderRadius: '5px', padding: '0rem 1rem' }}>
                                            <button
                                                style={{ display: 'flex', alignItems: 'center', fontSize: '15px', color: '#052c65', height: '2.5rem' }}
                                                type="button"
                                                onClick={() => toggleMenu(e.Menu_ID)}
                                            >
                                                {e.Menu_Name} {expandedMenuId === e.Menu_ID ? "▼" : "▶"}
                                            </button>
                                        </h2>
                                        <div id={`panelsStayOpen-collapse-${e.Menu_ID}`} style={{ backgroundColor: "#c8e5fc", display: "flex", justifyContent: "space-between", fontWeight: 600, marginTop: 10, padding: 10, border: '1px solid black' }}>
                                            <b>{e.Menu_Name}</b>
                                            <div style={{ display: 'flex' }}>
                                                <span className='mx-2' style={{ display: 'flex', gap: '5px' }}><b>Access Rights</b><input type='checkbox' onClick={(ev) => objectpusher(ev.currentTarget, e.Menu_ID)} /></span>
                                            </div>
                                        </div>
                                        <div id={`panelsStayOpen-collapse-${e.Menu_ID}`} className={`accordion-collapse collapse ${expandedMenuId === e.Menu_ID ? 'show' : ''}`} aria-labelledby={`heading-${e.Menu_ID}`}>
                                            <div className="accordion-body">
                                                {options.map((x, index) => {
                                                    if (e.Menu_ID === x.Summenuid) {
                                                        return (
                                                            <div key={index} style={{ display: 'flex', justifyContent: 'space-between', height: '2.5rem', alignItems: 'end', borderBottom: '1px solid black', padding: '0px 10px' }}>
                                                               <div style={{display:'flex',justifyContent:'left'}}> <label> {x.Menu_Name}</label></div>
                                                                <div style={{ display: 'flex' }}>
                                                                    <span className='mx-2'><b>Access Right</b><input type='checkbox' onClick={(ev) => objectpusher(ev.currentTarget, x.Menu_ID)} /></span>
                                                                </div>
                                                            </div>
                                                        )
                                                    }

                                                })}
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </>
                        )
                    }

                }
                ) : null}
                <div style={{ display: 'flex', gap: '10px' }}>
                    <button type="submit" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: "20px", width: "7rem", height: "2.5rem", backgroundColor: '#502eff', border: 'none', fontSize: '17px', gap: '4px' }}>Create Role </button>
                    <button onClick={resetData} type='button' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: "20px", width: "7rem", height: "2.5rem", backgroundColor: 'red', border: 'none', fontSize: '17px', gap: '4px' }}> Reset</button>
                </div>
            </Form>
        </div>
    )
}

export default CreateDepartment
